<div class="card">
  <ng-content />
</div>